import { render, staticRenderFns } from "./ApprovalPage.vue?vue&type=template&id=8a2d5ff4"
import script from "./ApprovalPage.vue?vue&type=script&lang=js"
export * from "./ApprovalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports